import { FC } from 'react'
import styled, { css } from 'styled-components'

interface IFProps {
  text: string
  className?: string
}

const PredictionInfoText: FC<IFProps> = ({ text, className }) => {
  return <StyledWrapper className={className}>{text}</StyledWrapper>
}

export default PredictionInfoText

const StyledWrapper = styled.p`
  ${({ theme }) => css`
    white-space: pre-wrap;
    font-size: 14px;
    letter-spacing: -0.56px;
    text-align: center;
    font-weight: normal;
    text-align: center;
    color: ${theme.color.text_1};
  `}
`
